module.exports = __webpack_public_path__ + "media/advantage/store-ffd089c4.jpg";